/*
Poornima 09/19/2022 2700799562 Fixed GAL-127,132,73,60,104 bugs
Poornima 09/20/2022 2700799562 Global field list code validation changes
Poornima 09/26/2022 2700799562 Fixed global field changes
Aditya 09/26/2022 2700799562 Implemented Save alert
Ashraf 09/29/2022 2700799562 fixed bugs on global fields
Aditya 09/29/2022 2700799562 Implemented save alert for Global Fields module
Aditya 09/29/2022 2700799562 Global field delete usage popup changes
Sohel 09/30/2022 2700799562 Global Field List ->Fixed Jira bugs
Sohel 09/30/2022 2700799562 Global Field List ->Added Copy Functionality(GAL-311) and Tabel Payload Changes.
ashraf 10/04/2022 2700799562 fixed copy, page break issue
sohel 10/06/2022 2700799562 Global Field List ->Fixed GAL-355,398
sohel 10/07/2022 2700799562 Record Format ->Download configuration payload changes and hide system notes
sohel 10/10/2022 2700799562  Global Field List ->Fixed GAL -455 and 456
sohel 10/14/2022 2700799562  Global Field ->Added Code Comments.
sohel 10/14/2022 2700799562 Global Field ->Added Code Comments Changes
Suresh 10/17/2022 2700799562 Design Enhancements in global Field Group, List
Ashraf 10/18/2022 2700799562 global field, group, field list UI changes
Suresh Peddavoora 10/20/2022 2700799562 Modified text field variant from standard to outlined.
Suresh Peddavoora 10/25/2022 2700799562 Text Fields Alignments Fixes.
Suresh Peddavoora 10/25/2022 2700799562 Button Alignments Fixes.
Prakash Gummala 11/02/2022 2700799562 Fixed Responsiveness for 768px.
Sohel 11/05/2022 2700799562 fixed Existing Field list codes Not auto populated Issue
Sohel 11/05/2022 2700799562 Existing Field list codes removed description
Ashraf 11/19/2022 2700799562 Existing Field list codes removed description
lalitha 11/29/2022 2700799562 changed width of dialog box
Gummala Prakash 11/29/2022 2700799562 Added Table Header for Table.
Sohel 11/30/2022 2700430604 Field List API and Field changes
Sohel 12/02/2022 2700799562 Global Field List Changes
Sohel 12/03/2022 3031450488 Global Field List deleted bugs.
lalitha 12/03/2022 3031450488 save button disabled when map field not selected and changed the title name and solved white space issue
Sohel 12/03/2022  2700799562 Global Field List validation Display Issue.
Sohel 12/03/2022 2700799562 fixed validation issue while copy fieldList
lalitha 12/03/2022 2700799562 Added AccountTreeIcon in map field button
Sohel 12/03/2022 2700799562 Save Payload Changes
Sai Maheshwar 12/03/2022 3031450488 added save and close in map fields
lalitha 12/03/2022 2700799562 Added Field validation in description field
Sohel 12/04/2022 2692790263 Added alertPopup
Sohel 12/06/2022 2692790263 field list code validation changes
Lalitha 12/07/202 2692790263 Rename Global Field List System Notes to  Field List System Notes
Lalitha  12/07/2022 2692790263  Rename Global Field List to Field List
Poornima  12/07/2022 2692790263 sent field list code as props
Poornima 12/08/2022 2701012930 Added download usage and configuration buttons
Rajesh 12/08/2022 2692790263 removed system notes.
Lalitha 12/09/2022  2692790263  Added reusable backButtonText
Rajesh 12/09/2022 2692790263 reset issue and back search enable
Ashraf 12/09/2022 2692790263 fixed success msg taost issue
Dilip 12/12/2022 2692790263 fixed error msg taost issue
Dilip 12/12/2022 2692790263 fixed back to search button disable issue
Ashraf 12/14/2022 2692790263 removed role access
Ashraf 12/14/2022 2692790263 fixed role access
Lalitha 12/15/2022 2692790263 Added Role Base Access
Rohini 12/20/2022 2692790263 Field List Code Alignments Fixed
Ashraf 01/02/2022 2692790263 renamed usage header title
Ashraf 01/12/2022 2692790263 fixed system notes copy issue
Suresh Peddavoora 01/13/2022 2692790263 Modified Button Spacing Alignments
Sohel 02/13/2022 2692790263 fixed fieldListCode validation issue
Ravi 02/20/2023 2692790263 fixed validation issue in code
suresh peddavoora 02/21/2023 2692790263 new UI changes for texfields and tables alignments
Akhila 02/22/2023 2692790263 Added preview file functionlity in download configuration
suresh peddavoora 02/24/2023 2692790263 New UI changes
 Rohini 03/01/2023 2692790263 worked on the code enhancements.
Ravi 03/01/2023 2692790263 Added loader and download toast message for preview File
Akhila 03/01/2023 2692790263 Added loader and download toast message for preview File
sohel 03/06/2023 2692790263 Added validation message for existing value
Prakash 03/17/2023 2692790263 fixed alignments in Responsive and desktop.
Raghu 03/20/2023 2692790263 fixed button alignments
Prakash 07-04-23 2692790263 fixed  check box color.
Prakash 04/26/2023 2692790263 fixed font size for dropdown
Akhila 05/30/2023 2692790263 bug fixed unsaved changes
Ravi 06/09/2023 2692790263 Added Breadcrums in preview
Ravi 06/20/2023 2692790263 Added Breadcrum in popup
Ravi 06/22/2023 2692790263 fixed submit issue
Akhila 07/01/2023 2692790263 field list name change to audit field list
Gireesh 12/11/2023 2692790263 added validation for audit field list code and description in audit field list
Gireesh 12/12/2023 2692790263 removed validation for audit field list code and description in audit field list
*/

import React, { useState, useEffect, useContext, useRef } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  MenuItem,
  TextField,
} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import DialogBox from '../../../../../components/DialogBox';
import { ThemeContext } from '../../../../../themes/ThemeProvider';
import AddFieldListTable from './AddFieldListTable';
import SearchFields from '../../DataRepositories/SearchDataRepositories/index';
import { useDispatch, useSelector } from 'react-redux';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import {
  getBaseCategory,
  postFieldList,
  resetMessage,
  resetAddFieldListStatus,
  fetchAllCodeAndDescription,
  getLinkedCategories,
  resetDownloadMessage,
  resetDefaultData,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import PageLoader from '../../../../../components/PageLoader';
import { SuccessSnackbar, ErrorSnackbar } from '../../../../../components/CustomSnackBar';
import OverrideRule from '../../../../../components/OverrideRule';
import SelectTabContextProvider from '../../../../../components/SelectTabContext/SelectTabContext';
import { ArrowBack } from '@material-ui/icons';
import { backButtonText, downloadButton } from '../../../../../util/Content';
import useUnsavedChangesWarning from '../../../../../util/CustomHooks';
import { setAlertData } from '../../../../../redux/reducers/UnsavedChangesAlertReducer';
import { postPrintUsage, resetPrintUsageData } from '../../../../../redux/reducers/printUsage';
import { printGlobalFieldList } from '../../../../../redux/reducers/GlobalField/AddFieldList';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import { getAllAuditListData } from '../../../../../redux/reducers/GlobalField/ClientAuditList';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import axios from 'axios';
import { resetDownloadMsg } from '../../../../../redux/reducers/PreviewFileData';
import BreadCrums from '../../../../../util/BreadCrum';
import { submissionStart } from '../../../../../redux/reducers/CommonActions/commonActions';

const AddFieldListForm = ({
  setTabValue,
  isCopyData,
  StepperFieldList,
  setShowSearch,
  AuditFieldList,
  setGlobalFieldList,
}) => {
  const {
    successMsg,
    fieldListPostStatus,
    isLoading,
    errorMsg,
    userMetrix,
    addGlobalFieldListData,
    addGlobalFieldListStatus,
    globalFieldListData,
    baseCategoryData,
    GlobalFieldListPrintStatus,
    defaultMessage,
    defaultCode,
    configurationUrl,
    dockey,
  } = useSelector(({ addFieldList }) => addFieldList);

  const initialVal = {
    fieldListCode: '',
    fieldListDescripton: '',
    category: '',
    otherCategory: '',
    isDefault: false,
  };
  const [selectedRows, setSelectedRows] = useState([]);
  const [joinArray, setJoinArray] = useState([]);
  const [groudArray, setGroudArray] = useState([]);
  const [fieldList, setFieldList] = useState([]);
  const [initialValues, setInitialValues] = useState(initialVal);
  const [deletedIds, setDeletedIds] = useState([]);
  const [joinArrDeletedIds, setJoinArrDeletedIds] = useState([]);
  const [overRiding, setOverRiding] = useState({});
  const [reset, setReset] = useState(false);
  const { globalFieldRow, setSaveTab } = useContext(SelectTabContextProvider);
  const { roleData } = useSelector(({ role }) => role);
  const { enabledSubmission } = useSelector(({ commonActions }) => commonActions);
  const disableAdd = roleData?.window?.['Audit Field List']?.['FL']?.add;
  const disableEdit = roleData?.window?.['Audit Field List']?.['FL']?.edit;
  // const disable = roleData?.window?.["Field List"]?.["FL"];
  const disable = roleData?.window?.['Audit Field List']?.['FL'];
  const [fieldCode, setFieldCode] = useState();
  const [codePopover, setCodePopover] = useState(false);
  const [fieldListCodesData, setFieldListCodesData] = useState();
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isWarning, setWarning] = useState(false);
  const [dirtyRef, setDirtyRef] = useState(false);
  const filteredCategory = baseCategoryData?.filter(
    (item) => item?.categoryCode !== 'AR' && item?.categoryCode !== 'P',
  );
  const printusage = useSelector(({ printusage }) => printusage);
  const isDisabledBaseCategory = useRef();
  const { reusableInputStyles } = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [dialogState, setDialogState] = useState(false);
  const fieldsDeleteIdsRef = useRef([]);

  const { auditListData } = useSelector(({ auditFieldList }) => auditFieldList);

  const schema = Yup.object().shape({
    fieldListCode:
      !isCopyData && globalFieldListData?.fieldListCode
        ? null
        : Yup.string()
          .test(
            'fieldListCode',
              `${
                AuditFieldList
                  ? 'Audit Field List Code already in use'
                  : 'Field List Code already in use'
              }`,
              (value) => !checkCodeExist(value),
          )
          .test(
            'fieldListCode',
              `${
                AuditFieldList
                  ? 'Audit Field List Code has already been used in the past'
                  : 'Field List Code has already been used in the past'
              }`,
              (value) => !checkCodeAlreadyExist(value),
          )
          .required(
              `${
                AuditFieldList ? 'Audit Field List Code is required' : 'Field List Code is required'
              }`,
          ),
    fieldListDescripton: Yup.string()
      .test(
        'fieldListDescripton',
        `${
          AuditFieldList
            ? 'Audit Field List Description is required'
            : 'Field List Description is required'
        }`,
        (value) => {
          return value?.replaceAll(' ', '');
        },
      )
      .required(
        `${
          AuditFieldList
            ? 'Audit Field List Description is required'
            : 'Field List Description is required'
        }`,
      ),
  });
  const getFieldListCodesData = () => {
    if (auditListData && auditListData?.length > 0) {
      return auditListData?.filter(
        (i) =>
          String(i?.fieldListCode)?.toLowerCase().startsWith(fieldListCodesData) &&
          i?.isActive === 'Y',
      );
    } else {
      return [];
    }
  };
  const showAlertRef = useRef(false);
  const { routerPrompt, onDirty, onPristine } = useUnsavedChangesWarning();
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };
  const [loading, setIsLoading] = useState(false);

  useEffect(() => {
    if (configurationUrl) {
      setIsLoading(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoading(false);
      }
      readData();
    }
  }, [configurationUrl]);

  const handleDirty = (dirty) => {
    showAlertRef.current = dirty;
    if (dirty) {
      onDirty();
    } else {
      onPristine();
    }
  };
  useEffect(() => {
    if (dirtyRef) {
      handleDirty(true);
    } else {
      handleDirty(false, 'reset');
    }
  }, [dirtyRef]);
  useEffect(() => {
    dispatch(getAllAuditListData(AuditFieldList ? 'AuditField' : 'Global'));
  }, []);

  const checkCodeExist = (value) => {
    if (auditListData && auditListData?.length > 0 && value) {
      const ar = [];
      auditListData.filter((i) => {
        if (
          i?.fieldListCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkCodeAlreadyExist = (value) => {
    if (auditListData && auditListData?.length > 0 && value) {
      const ar = [];
      auditListData.filter((i) => {
        if (
          i?.fieldListCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleDialogState = () => {
    setDialogState(false);
  };
  const getCategoryObject = (value, data) => {
    const category = data && data?.filter((i) => i?.categoryCode === value);
    if (category?.length > 0) {
      return category[0];
    }
  };
  useEffect(() => {
    if (addGlobalFieldListStatus === 200 && userMetrix === 'Yes') {
      setDialogState(true);
      setTimeout(() => {
        dispatch(resetAddFieldListStatus());
      }, 2500);
    }
  }, [userMetrix, addGlobalFieldListStatus]);

  useEffect(() => {
    if (fieldListPostStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
        dispatch(resetDefaultData());
        if (StepperFieldList) {
          setGlobalFieldList(fieldCode);
          setShowSearch(false);
        } else {
          setTabValue(0);
        }
      }, 2000);
    }
  }, [fieldListPostStatus]);
  useEffect(() => {
    if (printusage.errorMsg || printusage.successMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printusage.errorMsg, printusage.successMsg]);
  useEffect(() => {
    if (GlobalFieldListPrintStatus === 200) {
      setTimeout(() => {
        dispatch(resetDownloadMessage());
        dispatch(resetDefaultData());
      }, 2000);
    }
  }, [GlobalFieldListPrintStatus]);
  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 1500);
    }
  }, [errorMsg]);

  useEffect(() => {
    if (Object.keys(globalFieldListData).length > 0) {
      const newInitialValues = {
        fieldListCode: isCopyData ? '' : globalFieldListData?.fieldListCode,
        fieldListDescripton: isCopyData ? '' : globalFieldListData?.fieldListDesc,
        category: getCategoryObject(globalFieldListData?.baseCategory, baseCategoryData),
        otherCategory: globalFieldListData?.linkedCategory,
        isDefault: isCopyData ? false : globalFieldListData?.isDefault === 'Y',
      };
      const data = {
        sourceCategory: [
          globalFieldListData?.baseCategory ? globalFieldListData?.baseCategory : '',
        ],
      };
      dispatch(getLinkedCategories(data));
      setInitialValues(newInitialValues);
      setFieldCode(globalFieldListData?.fieldListCode);

      const fieldsTableData = globalFieldListData?.fieldListFieldMapList?.map((field) => {
        return {
          category: field?.catagory,
          fieldListCode: field?.fieldListCode,
          fieldListFieldId: isCopyData ? 0 : field?.fieldListFieldId,
          fieldName: field?.fieldName,
          fieldType: field?.fieldType,
          repositoryName: field?.repositoryName,
          repositoryType: field?.repositoryType,
          dataRepositoryId: field?.dataRepositoryId || 0,
          fieldId: field?.fieldId || 0,
        };
      });

      // Remove duplicate fields
      const uniqueArray = fieldsTableData.filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            (t) => t.repositoryName === value.repositoryName && t.fieldName === value.fieldName,
          ),
      );
      setSelectedRows(uniqueArray);
    }
  }, [globalFieldListData, reset]);
  const handleSubmit = (data) => {
    dispatch(submissionStart());
    const mapFieldListData = selectedRows?.map((item) => {
      return {
        catagory: item?.category ? item?.category : '',
        fieldListCode: data?.fieldListCode ? data?.fieldListCode : '',
        fieldListFieldId: item?.fieldListFieldId ? item?.fieldListFieldId : 0,
        fieldName: item?.fieldName ? item?.fieldName : '',
        fieldType: item?.fieldType ? item?.fieldType : '',
        repositoryName: item?.repositoryName ? item?.repositoryName : '',
        repositoryType: item?.repositoryType ? item?.repositoryType : '',
        dataRepositoryId: item?.dataRepositoryId ? item?.dataRepositoryId : '',
        fieldId: item?.repositoryFieldId || item?.fieldId || 0,
      };
    });
    const deletedField = fieldsDeleteIdsRef.current?.filter(Boolean);
    const passValues = {
      baseCategory: data?.category?.categoryCode ? data?.category?.categoryCode : '',
      fieldListCode: data?.fieldListCode ? data?.fieldListCode : '',
      fieldListDesc: data?.fieldListDescripton ? data?.fieldListDescripton : '',
      fieldListId: isCopyData
        ? 0
        : globalFieldListData?.fieldListId
          ? globalFieldListData?.fieldListId
          : 0,
      fieldListRepoFieldMapList: mapFieldListData,
      mapDeleteIds: deletedField?.length > 0 ? deletedField : [0],
      oldFieldListCode: isCopyData ? globalFieldListData?.fieldListCode : '',
      override: 'No',
      linkedCategory: data?.otherCategory ? data?.otherCategory : [],
      tabType: AuditFieldList ? 'AuditField' : 'Global',
      overrideType: 'FIELD LIST',
      defaultFieldListCode: '',
      isDefault: data?.isDefault ? 'Y' : 'N',
      isCopy: isCopyData ? 'Yes' : 'No',
    };
    setOverRiding(passValues);
    dispatch(postFieldList(passValues, AuditFieldList));
  };

  window.onclick = function () {
    setCodePopover(false);
  };
  useEffect(() => {
    isDisabledBaseCategory.current = true;
  }, []);

  useEffect(() => {
    dispatch(fetchAllCodeAndDescription());
    dispatch(getBaseCategory());
    setSaveTab(false);
  }, []);

  useEffect(() => {
    if (defaultMessage && defaultMessage === 'Yes') {
      setIsOpen(true);
    }
  }, [defaultMessage]);

  const handleDefaultClose = () => {
    setIsOpen(false);
    dispatch(resetDefaultData());
  };

  const handleWarnClose = () => {
    setWarning(false);
  };

  return (
    <div>
      <DeleteTableRecordPopup
        open={isOpen}
        dialogClose={handleDefaultClose}
        title={`Override default audit list`}
        value={`Are you sure want to set this ${overRiding?.fieldListCode?.toUpperCase()} audit list as default by overriding ${defaultCode}`}
        buttonCondition={''}
        handleClose={() => {
          handleDefaultClose();
        }}
        handleSubmit={() => {
          dispatch(
            postFieldList({ ...overRiding, defaultFieldListCode: defaultCode }, AuditFieldList),
          );
          setIsOpen(true);
        }}
      />
      <DeleteTableRecordPopup
        open={isWarning}
        dialogClose={handleWarnClose}
        title={`Default Audit`}
        value={`Can't remove default audit list, atleast one audit list should be default.`}
        buttonCondition={'Default Audit'}
        handleClose={() => {
          handleDefaultClose();
        }}
        handleSubmit={() => {}}
      />
      {/* <DefaultListPopup maxWidth="lg" open={isOpen} setOpen={setIsOpen} value={"Do you want to set this as default by overriding "} /> */}
      <div className={`mb-0`}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleBlur,
              handleReset,
              setFieldValue,
              resetForm,
              touched,
              errors,
              dirty,
            } = props;
            // handleDirty(dirty);
            if (dirty) {
              setDirtyRef(dirty);
            }
            return (
              <div className="new-standard-textfields">
                {routerPrompt}
                {!StepperFieldList && (
                  <div className="button-table-spacing-mb justify-content-between">
                    <Button
                      variant="outlined"
                      type="button"
                      // disabled={isLoading}
                      className={`search-btn ${classes.buttonRoot}`}
                      onClick={() => {
                        if (showAlertRef.current) {
                          dispatch(
                            setAlertData({
                              showAlert: showAlertRef.current,
                              alertCallback: () => {
                                setTabValue(0);
                              },
                            }),
                          );
                        } else {
                          setTabValue(0);
                        }
                      }}
                    >
                      <ArrowBack className="mr-2" />
                      {backButtonText}
                    </Button>
                    {globalFieldListData?.fieldListCode && !isCopyData && (
                      <div>
                        {!AuditFieldList && (
                          <Button
                            type="button"
                            variant="outlined"
                            className={`mx-1 search-btn`}
                            // disabled={fieldListDataUsage.userMetrix === "No"}
                            onClick={(event) => {
                              dispatch(
                                postPrintUsage({
                                  baseCategory: globalFieldListData?.baseCategory
                                    ? globalFieldListData?.baseCategory?.split('-')?.[0]
                                    : '',
                                  code: globalFieldListData?.fieldListCode
                                    ? globalFieldListData.fieldListCode
                                    : '',
                                  description: globalFieldListData?.fieldListDesc
                                    ? globalFieldListData?.fieldListDesc
                                    : '',
                                  displayName: '',
                                  fileType: '',
                                  recordFormatType: '',
                                  returnType: '',
                                  sourceType: 'FIELD LIST',
                                  search: '',
                                  // search: search,
                                  frameworkUsageOrderBy: '',
                                  // tableRef?.current?.dataManager?.orderBy === 0
                                  //   ? "targetType"
                                  //   : tableRef?.current?.dataManager?.orderBy === 1
                                  //   ? "targetCode"
                                  //   : tableRef?.current?.dataManager?.orderBy === 2
                                  //   ? "targetDescription"
                                  //   : "",
                                  frameworkUsageOrderDerection: '',
                                  // tableRef?.current?.dataManager
                                  // ?.orderDirection
                                  // ? tableRef?.current?.dataManager?.orderDirection
                                  // : "",
                                  fieldListOrderBy: '',
                                  fieldListOrderDerection: '',
                                }),
                              );
                            }}
                          >
                            Download Configuration Usage
                          </Button>
                        )}
                        <Button
                          type="button"
                          variant="outlined"
                          className={`mx-1 search-btn`}
                          // disabled={Boolean(dataCount === 0)}
                          onClick={(event) => {
                            dispatch(
                              printGlobalFieldList(
                                {
                                  baseCategory: globalFieldListData?.baseCategory
                                    ? globalFieldListData?.baseCategory?.split('-')?.[0]
                                    : '',
                                  fieldListCode: globalFieldListData?.fieldListCode
                                    ? globalFieldListData.fieldListCode
                                    : '',
                                  fieldListDesc: globalFieldListData?.fieldListDesc
                                    ? globalFieldListData?.fieldListDesc
                                    : '',
                                  search: '',
                                  orderBy: '',
                                  orderDirection: '',
                                  tabType: AuditFieldList ? 'AuditField' : 'Global',
                                },
                                AuditFieldList,
                              ),
                            );
                          }}
                        >
                          {downloadButton}
                        </Button>
                      </div>
                    )}
                  </div>
                )}
                <Form autoComplete="off" noValidate onReset={handleReset}>
                  <div>
                    <ErrorBoundaryForComponents>
                      <div className="form-row  global-field-textfields new-standard-textfields">
                        <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                              popper: classes.popper,
                            }}
                            name="category"
                            id="category"
                            size="small"
                            value={values.category}
                            options={filteredCategory}
                            disabled={isDisabledBaseCategory.current && selectedRows?.length > 0}
                            getOptionLabel={(option) => {
                              return option && option.categoryName
                                ? option.categoryCode === null
                                  ? option.categoryName
                                  : option.categoryCode + ' - ' + option.categoryName
                                : '';
                            }}
                            onChange={(e, value) => {
                              setFieldValue('otherCategory', '');
                              if (value) {
                                setFieldValue('category', value);
                                const data = {
                                  sourceCategory: [value?.categoryCode],
                                };
                                dispatch(getLinkedCategories(data));
                              }
                            }}
                            placeholder="Select Category"
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  className={`${classes.labelName}`}
                                  {...params}
                                  error={touched.category && errors.category}
                                  variant="outlined"
                                  margin="dense"
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  label="Base Category"
                                  placeholder="Select Base Category"
                                />
                              </div>
                            )}
                          />
                        </div>
                        <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 form-group">
                          <TextField
                            margin="dense"
                            className={`${classes.labelName}`}
                            variant="outlined"
                            placeholder={`Enter ${AuditFieldList ? 'Audit' : ''} Field List Code`}
                            label={`${AuditFieldList ? 'Audit' : ''} Field List Code`}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            name="fieldListCode"
                            inputProps={{ maxLength: 25 }}
                            value={values?.fieldListCode}
                            required
                            disabled={!isCopyData && globalFieldListData?.fieldListCode}
                            onChange={(e) => {
                              setFieldValue('fieldListCode', e.target.value);
                              setFieldCode(e.target.value?.toUpperCase());
                              if (e.target.value) {
                                setCodePopover(true);
                                setFieldListCodesData(e.target.value);
                              } else if (e.target.value === '') {
                                setCodePopover(false);
                              }
                            }}
                            onBlur={handleBlur}
                            fullWidth
                            touched={touched.fieldListCode}
                            error={Boolean(touched.fieldListCode && errors.fieldListCode)}
                          />
                          <FormHelperText>
                            {touched.fieldListCode && errors.fieldListCode && errors.fieldListCode}
                          </FormHelperText>
                          <div className="windowcode-popover Add-trigger-group-popover">
                            {!errors.fieldListCode &&
                              codePopover &&
                              getFieldListCodesData()?.map((data, i) => (
                                <MenuItem key={i}>{data?.fieldListCode}</MenuItem>
                              ))}
                          </div>
                        </div>
                        <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 form-group">
                          <TextField
                            margin="dense"
                            className={`${classes.labelName}`}
                            variant="outlined"
                            placeholder={`Enter ${
                              AuditFieldList ? 'Audit' : ''
                            } Field List Description`}
                            label={`${AuditFieldList ? 'Audit' : ''} Field List Description`}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            name="fieldListDescripton"
                            value={values.fieldListDescripton}
                            required
                            inputProps={{ maxLength: 100 }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            touched={touched.fieldListDescripton}
                            error={Boolean(
                              touched.fieldListDescripton && errors.fieldListDescripton,
                            )}
                          />
                          <FormHelperText>
                            {touched.fieldListDescripton &&
                              errors.fieldListDescripton &&
                              errors.fieldListDescripton}
                          </FormHelperText>
                        </div>

                        {AuditFieldList && (
                          <div className="col-sm-6 col-xs-6 col-md-3 form-group">
                            <FormControl component="fieldset">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    onChange={(e, value) => {
                                      handleChange(e);
                                      if (globalFieldListData?.isDefault === 'Y') {
                                        setFieldValue('isDefault', true);
                                        setWarning(true);
                                      } else {
                                        setFieldValue('isDefault', e.target.checked);
                                      }
                                    }}
                                    // disabled={values?.auditNote}
                                    name="isDefault"
                                    checked={values?.isDefault}
                                  />
                                }
                                label="Set as default"
                                labelPlacement="end"
                              />
                            </FormControl>
                          </div>
                        )}
                      </div>
                    </ErrorBoundaryForComponents>
                    {isLoading || loading ? <PageLoader /> : ''}
                    {printusage?.isLoading && <PageLoader />}
                    {(errorMsg || printusage?.errorMsg) && (
                      <ErrorSnackbar errorMsg={errorMsg || printusage?.errorMsg} />
                    )}
                    {(successMsg || printusage?.successMsg) && (
                      <SuccessSnackbar successMsg={successMsg || printusage?.successMsg} />
                    )}
                  </div>
                  <div className="table-header table-card-header justify-content-end">
                    <Button
                      variant="outlined"
                      className={`search-btn ${classes.buttonRoot}`}
                      onClick={() => setOpen(true)}
                      disabled={
                        globalFieldListData?.fieldListCode && !isCopyData && disable?.edit === false
                      }
                      startIcon={<AccountTreeIcon />}
                    >
                      Map Fields
                    </Button>
                  </div>
                  <AddFieldListTable
                    selectedRows={selectedRows}
                    joinArray={joinArray}
                    setJoinArray={setJoinArray}
                    setFieldList={setFieldList}
                    fieldList={fieldList}
                    groudArray={groudArray}
                    setGroudArray={setGroudArray}
                    setSelectedRows={setSelectedRows}
                    deletedIds={deletedIds}
                    setDeletedIds={setDeletedIds}
                    joinArrDeletedIds={joinArrDeletedIds}
                    setJoinArrDeletedIds={setJoinArrDeletedIds}
                    values={values}
                    setFieldValue={setFieldValue}
                    fieldsDeleteIdsRef={fieldsDeleteIdsRef}
                    fieldListCode={values?.fieldListCode}
                    isCopyData={isCopyData}
                    setDirtyRef={setDirtyRef}
                  />
                  <div className="row justify-content-center mt-3">
                    <Button
                      variant="outlined"
                      type="reset"
                      disabled={
                        globalFieldListData?.fieldListCode && !isCopyData && disable?.edit === false
                      }
                      onClick={() => {
                        fieldsDeleteIdsRef.current = [];
                        if (!Object.keys(globalFieldListData)?.length > 0) {
                          setSelectedRows([]);
                          resetForm();
                        } else {
                          setReset(!reset);
                        }
                      }}
                      className={`mr-1 reset-btn ${classes.buttonRoot}`}
                    >
                      Reset
                    </Button>
                    <Button
                      disabled={
                        (!disableAdd && globalFieldRow === false) ||
                        (globalFieldRow && !disableEdit) ||
                        selectedRows?.length === 0 ||
                        enabledSubmission
                      }
                      variant="outlined"
                      type="submit"
                      className={`search-btn ml-1 ${classes.buttonRoot}`}
                    >
                      Save
                    </Button>
                  </div>
                </Form>

                <DialogBox
                  open={open}
                  dialogClose={handleClose}
                  // title="Search Repository Fields"
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Search Repository Fields</b>
                      </p>
                      <BreadCrums
                        name={'Audit Field List Code'}
                        code={globalFieldListData?.fieldListCode}
                        description={'Audit Field List Description'}
                        descriptionValue={globalFieldListData?.fieldListDesc}
                      />
                    </div>
                  }
                  maxWidth="xl"
                >
                  <SearchFields
                    isGlobalFieldList={true}
                    isReports={true}
                    setSelectedRows={setSelectedRows}
                    selectedRows={selectedRows}
                    setFormikFieldValue={setFieldValue}
                    values={values}
                    mapFields={true}
                    tempSelectedRows={tempSelectedRows}
                    handleClose={handleClose}
                    setTempSelectedRows={setTempSelectedRows}
                    fieldsDeleteIdsRef={fieldsDeleteIdsRef}
                  />
                </DialogBox>
                <OverrideRule
                  dialogTitle="Override Field List"
                  dialogOpen={dialogState}
                  dialogClose={handleDialogState}
                  title={`The Field List is used in the following places.`}
                  data={addGlobalFieldListData}
                  handleDialogState={handleDialogState}
                  handleOverrideClose={() => {
                    handleDialogState(false);
                  }}
                  handleOverrideSubmit={() => {
                    dispatch(postFieldList({ ...overRiding, override: 'Yes' }, AuditFieldList));
                    handleDialogState(true);
                  }}
                />
                <PreviewFileDialog
                  open={configOpen}
                  dialogClose={handleConfigClose}
                  fileUrl={configurationUrl}
                  configData={configData}
                  dockey={dockey}
                  moduleName={'Audit Field List'}
                  name={'Audit Field List Code'}
                  code={globalFieldListData?.fieldListCode}
                  description={'Audit Field List Description'}
                  descriptionValue={globalFieldListData?.fieldListDesc}
                />
              </div>
            );
          }}
        </Formik>
      </div>
      {/* {!isCopyData && globalFieldListData?.fieldListCode && (
        <div className={`${classes1.root} mt-3`}>
          <Accordion
            className="accordion-styling"
            expanded={expanded === "panel1"}
            onChange={handleAccordionChange("panel1")}
          >
            <AccordionSummary
              expandIcon={<ExpandMore sx={{ fontSize: "0.9rem" }} />}
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <Typography className={classes1.heading}>Field List System Notes</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <GlobalFieldListSystemNotes filedListCode={globalFieldListData?.fieldListCode} />
            </AccordionDetails>
          </Accordion>
        </div>
      )} */}
    </div>
  );
};

export default AddFieldListForm;
